import apiService from "./apiService";

export const getNurseUser = (query) => {
  let queryParams = {
    q: query?.nurse,
    page: query?.page ?? 1,
    item_per_page: 10,
  }
  return apiService.get(URIS.nurse, {params: queryParams})
}

export const createNurseUser = (data) => {
  return apiService.post(URIS.nurse, data)
}

export const changeNurseStatus = (payload) => {
  return apiService.patch(URIS_D("nurse_status", payload.id), {status: payload.status}
  )
}

const URIS = {
  nurse: '/v1/admin/nurses',
}

const URIS_D = (url, param1) => {
  return {
    nurse_status: `/v1/admin/nurses/${param1}`,
  }[url]
}

